import React from "react";
import { FaBell, FaTimes } from "react-icons/fa";
import { formatReminderDate, getReminderHistory } from "../helpers";

const ReminderHistoryModal = ({ isOpen, reglement, onClose }) => {
  if (!isOpen || !reglement) return null;

  const reminders = getReminderHistory(reglement);

  const userName = `${reglement.User?.prenom || ""} ${
    reglement.User?.nom || ""
  }`.trim();

  const articleName = reglement.Article?.nom || "Règlement Inscription";

  return (
    <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-slate-950/50 px-3 py-4 backdrop-blur-sm sm:items-center">
      <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <div className="bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500 px-5 py-4 text-white">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2">
                <FaBell className="text-lg" />
                <h3 className="text-lg font-bold">
                  Historique des rappels
                </h3>
              </div>

              <p className="mt-1 text-sm text-white/90">
                {userName || "Utilisateur"} — {articleName}
              </p>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="max-h-[65vh] overflow-y-auto px-5 py-5">
          {reminders.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center text-sm text-slate-600 dark:border-slate-700 dark:bg-slate-800/50 dark:text-slate-300">
              Aucun rappel envoyé pour ce paiement.
            </div>
          ) : (
            <div className="space-y-3">
              <div className="rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-900 ring-1 ring-amber-200 dark:bg-amber-950/30 dark:text-amber-100 dark:ring-amber-800">
                Total :{" "}
                <span className="font-bold">
                  {reminders.length} rappel(s)
                </span>
              </div>

              <ul className="space-y-2">
                {reminders
                  .slice()
                  .reverse()
                  .map((reminder, index) => (
                    <li
                      key={`${reminder.sent_at || "reminder"}-${index}`}
                      className="rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm dark:border-slate-700 dark:bg-slate-800/70"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="text-sm font-bold text-slate-900 dark:text-white">
                            Rappel #{reminders.length - index}
                          </p>
                          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                            {formatReminderDate(reminder.sent_at)}
                          </p>
                        </div>

                        <span className="rounded-full bg-orange-100 px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-orange-700 dark:bg-orange-950/50 dark:text-orange-200">
                          {reminder.channel || "email"}
                        </span>
                      </div>

                      {reminder.subject ? (
                        <p className="mt-2 text-xs text-slate-600 dark:text-slate-300">
                          {reminder.subject}
                        </p>
                      ) : null}
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>

        <div className="border-t border-slate-200 bg-slate-50 px-5 py-4 text-right dark:border-slate-700 dark:bg-slate-950/40">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-[42px] items-center justify-center rounded-xl bg-slate-900 px-5 text-sm font-bold text-white transition hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReminderHistoryModal;